import { SVGProps } from "react";

export const PersonaIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={18}
    height={15}
    viewBox="0 0 18 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="Group">
      <path
        id="Vector"
        d="M7.57913 7.03208L8.75064 7.4532C10.6591 8.33372 12.0396 10.1932 12.2761 12.2824C12.3421 12.8785 12.3861 14.0708 12.3146 14.6505C12.2981 14.7981 12.2046 14.9403 12.0726 15.0005H0.280631C0.143131 14.9403 0.055131 14.7981 0.038631 14.6505C-0.032869 14.0762 0.011131 12.9004 0.077131 12.3152C0.346631 9.80489 2.28813 7.58992 4.77963 7.0649L3.97663 6.58909C1.98013 5.10151 2.03513 2.08259 4.08663 0.671574C6.13813 -0.739442 8.83864 0.179359 9.64714 2.44902C10.2961 4.27568 9.38864 6.31564 7.58464 7.02661L7.57913 7.03208ZM5.89063 0.830176C3.90513 1.02159 2.71163 3.18187 3.60813 4.95931C4.60363 6.93364 7.44164 7.0649 8.61314 5.17807C9.86714 3.15999 8.25014 0.605945 5.89063 0.830176ZM11.5116 14.2184C11.6051 12.5504 11.4181 11.0354 10.3511 9.70098C7.90364 6.64378 3.05813 7.18521 1.36413 10.7073C0.825131 11.8339 0.814131 12.9933 0.841631 14.2184H11.5061H11.5116Z"
        fill="currentColor"
      />
      <path
        id="Vector_2"
        d="M11.9902 3.23682L17.7817 3.25322C18.0897 3.45011 18.0677 3.83294 17.7432 3.99701L12.1607 4.02983C11.6712 3.97514 11.5557 3.45011 11.9902 3.23682Z"
        fill="currentColor"
      />
      <path
        id="Vector_3"
        d="M11.9903 5.50098H17.6663C18.1173 5.54473 18.1338 6.23383 17.5618 6.29399H12.1553C11.6658 6.2393 11.5503 5.71427 11.9848 5.50098H11.9903Z"
        fill="currentColor"
      />
      <path
        id="Vector_4"
        d="M12.1 7.6665H15.422C15.9555 7.73213 15.8895 8.4103 15.4605 8.45952H12.056C11.5885 8.34467 11.6215 7.74307 12.1 7.6665Z"
        fill="currentColor"
      />
    </g>
  </svg>
);
